/* ZENOURA PERSONLIG BETJENING (13/10 2026, ombygget 14/10 2026).
   Snippet: zenoura-betjening.liquid.

   Regner i DANSK tid (Europe/Copenhagen), uanset hvor kunden sidder:
   - dagens person: har A og B samme navn, er det EEN person, og A's foto
     bruges alle dage. Ellers lige dag i aaret = A, ulige = B
   - boblen vises KUN naar der er aabent (og zen_bet_pop_on er taendt)
   - Ring-knappen vises KUN naar der er aabent; lukket = kun "Skriv en mail"
   - aaben/lukket: mandag-fredag fra {fra} til {til}
   - {naeste}: "i dag" (hverdag foer aabning), "i morgen" (man-tor efter
     lukketid), "mandag" (fredag efter lukketid, loerdag, soendag)

   TEST-KROG: saet window.ZEN_BET_NOW = '2026-10-16T19:30:00+02:00' (en
   ISO-streng) foer eller efter indlaesning. Den laeses ved HVER opdatering,
   saa efter en aendring kan window.ZenBet.refresh() kaldes for at se
   resultatet med det samme (ellers sker det ved naeste aabning af kortet
   eller inden for et minut). */
(function () {
  'use strict';

  var roots = document.querySelectorAll('[data-zbet-root]');
  if (!roots.length) return;

  var cfg = null;
  for (var i = 0; i < roots.length && !cfg; i++) {
    try { cfg = JSON.parse(roots[i].getAttribute('data-zbet-cfg') || ''); } catch (e) { cfg = null; }
  }
  if (!cfg) return;

  var FROM = Number(cfg.from);
  var TO = Number(cfg.to);
  if (isNaN(FROM)) FROM = 10;
  if (isNaN(TO)) TO = 18;

  var card = document.querySelector('[data-zbet-card]');
  var bubble = document.querySelector('[data-zbet-bubble]');
  var closeBtn = card ? card.querySelector('[data-zbet-close]') : null;
  var lastTrigger = null;
  var closeTimer = null;

  /* ---------- Tid ---------- */
  function now() {
    var iso = window.ZEN_BET_NOW;
    if (iso) {
      var d = new Date(iso);
      if (!isNaN(d.getTime())) return d;
    }
    return new Date();
  }

  /* Dansk dato og klokkeslaet som tal. Ugedag og dag-i-aaret regnes ud fra
     tallene i UTC, saa sprogets ugedagsnavne aldrig er i spil. */
  function dkParts(d) {
    var y, m, day, h, min;
    try {
      var parts = new Intl.DateTimeFormat('da-DK', {
        timeZone: 'Europe/Copenhagen',
        year: 'numeric', month: 'numeric', day: 'numeric',
        hour: 'numeric', minute: 'numeric', hourCycle: 'h23'
      }).formatToParts(d);
      parts.forEach(function (p) {
        if (p.type === 'year') y = +p.value;
        else if (p.type === 'month') m = +p.value;
        else if (p.type === 'day') day = +p.value;
        else if (p.type === 'hour') h = +p.value % 24;
        else if (p.type === 'minute') min = +p.value;
      });
    } catch (e) { /* falder igennem til lokal tid */ }
    if (!y || !m || !day || isNaN(h) || isNaN(min)) {
      y = d.getFullYear(); m = d.getMonth() + 1; day = d.getDate();
      h = d.getHours(); min = d.getMinutes();
    }
    var utc = Date.UTC(y, m - 1, day);
    return {
      utc: utc,
      weekday: new Date(utc).getUTCDay(), /* 0 = soendag, 1 = mandag */
      yday: Math.round((utc - Date.UTC(y, 0, 1)) / 86400000) + 1,
      hour: h + min / 60
    };
  }

  /* ---------- Danske helligdage = lukket hele dagen ----------
     Faste: 1/1, 5/6 (grundlovsdag), 24/12, 25/12, 26/12, 31/12.
     Paaskebaserede: skaertorsdag, langfredag, paaskedag, 2. paaskedag,
     Kristi himmelfartsdag, pinsedag, 2. pinsedag. Paaske: Meeus/Butcher. */
  var DAY = 86400000;
  var easterCache = {};
  function easterUtc(y) {
    if (easterCache[y]) return easterCache[y];
    var a = y % 19, b = Math.floor(y / 100), c = y % 100;
    var d = Math.floor(b / 4), e = b % 4;
    var f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3);
    var h = (19 * a + b - d - g + 15) % 30;
    var i = Math.floor(c / 4), k = c % 4;
    var l = (32 + 2 * e + 2 * i - h - k) % 7;
    var m = Math.floor((a + 11 * h + 22 * l) / 451);
    var month = Math.floor((h + l - 7 * m + 114) / 31);
    var day = ((h + l - 7 * m + 114) % 31) + 1;
    easterCache[y] = Date.UTC(y, month - 1, day);
    return easterCache[y];
  }

  /* utc = midnat UTC for den danske kalenderdato. */
  function erHelligdag(utc) {
    var d = new Date(utc);
    var y = d.getUTCFullYear(), md = (d.getUTCMonth() + 1) + '/' + d.getUTCDate();
    if (['1/1', '6/5', '12/24', '12/25', '12/26', '12/31'].indexOf(md) !== -1) return true;
    var diff = Math.round((utc - easterUtc(y)) / DAY);
    /* -3 skaertorsdag, -2 langfredag, 0 paaskedag, 1 2. paaskedag,
       39 Kristi himmelfartsdag, 49 pinsedag, 50 2. pinsedag */
    return [-3, -2, 0, 1, 39, 49, 50].indexOf(diff) !== -1;
  }

  function erAabningsdag(utc) {
    var wd = new Date(utc).getUTCDay();
    return wd >= 1 && wd <= 5 && !erHelligdag(utc);
  }

  var UGEDAGE = ['søndag', 'mandag', 'tirsdag', 'onsdag', 'torsdag', 'fredag', 'lørdag'];

  function state() {
    var p = dkParts(now());
    var today = erAabningsdag(p.utc);
    var open = today && p.hour >= FROM && p.hour < TO;
    var next;
    if (today && p.hour < FROM) {
      next = 'i dag';
    } else {
      /* Naeste rigtige aabningsdag (hoejst 14 dage frem). */
      var n = 1;
      while (n < 14 && !erAabningsdag(p.utc + n * DAY)) n++;
      next = n === 1 ? 'i morgen' : UGEDAGE[new Date(p.utc + n * DAY).getUTCDay()];
    }
    return { open: open, next: next, yday: p.yday };
  }

  /* ---------- Person ---------- */
  function has(name, img) { return !!((name && String(name).trim()) || img); }

  function person(yday) {
    var aHas = has(cfg.an, cfg.ai);
    var bHas = has(cfg.bn, cfg.bi);
    var an = String(cfg.an || '').trim();
    var bn = String(cfg.bn || '').trim();
    var same = !!an && an.toLowerCase() === bn.toLowerCase();
    var useB = yday % 2 === 1;
    if (!bHas || same) useB = false;
    if (!aHas && bHas) useB = true;
    return useB
      ? { name: (cfg.bn || '').trim(), img: cfg.bi || '' }
      : { name: (cfg.an || '').trim(), img: cfg.ai || '' };
  }

  /* Klokkeslaet maa aldrig deles over to linjer: "10-18", "kl. 18" og "mandag kl. 10"
     pakkes i span.zbet-nw (white-space: nowrap). Skabelonen escapes FOER
     spans saettes ind, saa innerHTML kun faar vores egen, sikre markup. */
  function esc(t) {
    return String(t).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  function fillHtml(text, next) {
    var nw = function (t) { return '<span class="zbet-nw">' + esc(t) + '</span>'; };
    return esc(text || '')
      .split('{naeste} kl. {fra}').join(nw(next + ' kl. ' + FROM))
      .split('{fra}-{til}').join(nw(FROM + '-' + TO))
      .split('kl. {til}').join(nw('kl. ' + TO))
      .split('{fra}').join(String(FROM))
      .split('{til}').join(String(TO))
      .split('{naeste}').join(esc(next));
  }

  function fill(text, next) {
    return String(text || '')
      .split('{fra}').join(String(FROM))
      .split('{til}').join(String(TO))
      .split('{naeste}').join(next);
  }

  /* Uden foto: chat-ikon, aldrig silhuet eller forbogstav (kontrol 13/10:
     silhuetten lignede et billede, der ikke var indlaest). */
  var ICON = '<svg class="zbet-av__chat" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M4 5.5A1.5 1.5 0 0 1 5.5 4h13A1.5 1.5 0 0 1 20 5.5v9a1.5 1.5 0 0 1-1.5 1.5H10l-4.2 3.6c-.3.3-.8 0-.8-.4V16h0a1 1 0 0 1-1-1z" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/><path d="M8 8.8h8M8 11.8h5" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>';

  function renderAvatar(el, p) {
    var key = p.img ? 'img:' + p.img : 'icon';
    el.classList.toggle('zbet-av--icon', !p.img);
    if (el.getAttribute('data-zbet-key') === key) return;
    el.setAttribute('data-zbet-key', key);
    el.textContent = '';
    if (p.img) {
      var img = document.createElement('img');
      img.src = p.img; img.alt = ''; img.width = 80; img.height = 80;
      img.decoding = 'async';
      el.appendChild(img);
    } else {
      el.innerHTML = ICON;
    }
  }

  /* Striben: foerste del er temaindstillingen zen_bet_stripe_text (24-timers-
     loeftet). Anden del vises KUN naar der er aabent OG dagens person har et
     navn: " I dag svarer Navn". Ellers intet, saa striben aldrig modsiger
     loeftet i weekenden. */
  function renderLine(el, p, s) {
    el.textContent = '';
    /* 14/10 2026 (kontrol-kunde): striben siger kun Benjis saetning; navnet baeres af boblen og kortet,
       saa 'I dag svarer' ikke kolliderer med 'inden for 24 timer' paa samme linje. */
    if (false && s.open && p.name) {
      el.appendChild(document.createTextNode(' I dag svarer '));
      var b = document.createElement('strong');
      b.className = 'zbet-stripe__name';
      b.textContent = p.name;
      el.appendChild(b);
    }
  }

  /* ---------- Opdatering af alt ---------- */
  var lastKey = '';
  function refresh() {
    var s = state();
    var p = person(s.yday);
    var key = s.open + '|' + s.next + '|' + p.name + '|' + p.img;
    if (key === lastKey) return s;
    lastKey = key;

    document.querySelectorAll('[data-zbet-av]').forEach(function (el) { renderAvatar(el, p); });
    document.querySelectorAll('[data-zbet-line]').forEach(function (el) { renderLine(el, p, s); });

    if (card) {
      var nameEl = card.querySelector('[data-zbet-name]');
      var status = card.querySelector('[data-zbet-status]');
      var statusText = card.querySelector('[data-zbet-status-text]');
      var ring = card.querySelector('[data-zbet-ring]');
      var actions = card.querySelector('[data-zbet-actions]');
      if (nameEl) nameEl.textContent = p.name || 'Kundeservice';
      if (status) status.setAttribute('data-state', s.open ? 'open' : 'closed');
      if (statusText) {
        statusText.innerHTML = s.open
          ? fillHtml(cfg.topen, s.next)
          : fillHtml(cfg.tclosed, s.next);
      }
      /* Ring KUN i aabningstiden. Lukket = kun "Skriv en mail". */
      if (ring) {
        var label = p.name ? 'Ring til ' + p.name : 'Ring til os';
        ring.textContent = label;
        ring.setAttribute('aria-label', label + (cfg.phoneraw ? ' på ' + cfg.phoneraw : ''));
        ring.hidden = !s.open;
      }
      if (actions) actions.classList.toggle('zbet-card__actions--one', !(ring && s.open));
    }
    if (bubble) {
      /* Boblen kraever foto; Liquid giver altid et (tema-asset som fallback, 13/10). */
      bubble.classList.toggle('zbet-bubble--nophoto', !p.img);
      bubble.setAttribute('aria-label', 'Få hjælp af ' + (p.name || 'kundeservice'));
      /* Boblen vises KUN i aabningstiden. */
      bubble.hidden = !s.open;
    }
    return s;
  }

  /* ---------- Kortet: aabn og luk ---------- */
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function setExpanded(on) {
    document.querySelectorAll('[data-zbet-open]').forEach(function (t) {
      t.setAttribute('aria-expanded', on ? 'true' : 'false');
    });
  }

  function isOpen() { return !!card && !card.hidden; }

  function openCard(trigger) {
    if (!card) return;
    lastKey = '';
    refresh();
    if (closeTimer) { window.clearTimeout(closeTimer); closeTimer = null; }
    lastTrigger = trigger || document.activeElement;
    card.hidden = false;
    /* Ny frame, saa overgangen faktisk koerer. */
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () { card.classList.add('is-open'); });
    });
    setExpanded(true);
    if (bubble) bubble.classList.add('is-hidden');
    if (closeBtn) closeBtn.focus({ preventScroll: true });
  }

  function closeCard(returnFocus) {
    if (!isOpen()) return;
    card.classList.remove('is-open');
    setExpanded(false);
    var done = function () {
      card.hidden = true;
      closeTimer = null;
      if (bubble) bubble.classList.remove('is-hidden');
    };
    if (reduce) done(); else closeTimer = window.setTimeout(done, 200);
    if (returnFocus && lastTrigger && typeof lastTrigger.focus === 'function') {
      try { lastTrigger.focus({ preventScroll: true }); } catch (e) { lastTrigger.focus(); }
    }
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    var opener = t.closest ? t.closest('[data-zbet-open]') : null;
    if (opener) {
      e.preventDefault();
      if (isOpen()) closeCard(true); else openCard(opener);
      return;
    }
    if (!isOpen()) return;
    if (t.closest && t.closest('[data-zbet-close]')) { closeCard(true); return; }
    /* Klik udenfor kortet lukker det. */
    if (!card.contains(t)) closeCard(false);
  });

  document.addEventListener('keydown', function (e) {
    if ((e.key === 'Escape' || e.key === 'Esc') && isOpen()) closeCard(true);
  });

  /* ---------- Boblen: placering over sticky koebsknap og preview-bjaelke ---------- */
  var desktopMq = window.matchMedia ? window.matchMedia('(min-width: 768px)') : null;
  var cookieRoot = document.getElementById('zenoura-cookie-root');

  function previewLift() {
    var pbar = document.getElementById('PBarNextFrameWrapper');
    if (!pbar) return 0;
    return Math.round(pbar.getBoundingClientRect().height) || 68;
  }

  function placeBubble() {
    var lift = previewLift();
    if (card) card.style.setProperty('--zbet-lift', lift + 'px');
    if (!bubble) return;

    var base = desktopMq && desktopMq.matches ? 24 : 16;
    var bottom = lift + base;

    /* Sticky koebsknap (zenoura-sticky-atc.liquid): synlig = .zsticky.is-visible.
       Bunden laeses fra CSS (lift + gap) og hoejden med offsetHeight, som
       ignorerer transform; saa er tallet rigtigt ogsaa midt i indkoersel. */
    var bar = document.querySelector('.zsticky.is-visible');
    if (bar) {
      var cs = window.getComputedStyle(bar);
      var barBottom = parseFloat(cs.bottom) || 0;
      var top = barBottom + bar.offsetHeight + 12;
      if (top > bottom) bottom = top;
    }
    /* Uden baren lægges iPhonens hjemme-streg oveni; med baren er den
       allerede med i barens egen hoejde. */
    bubble.style.setProperty('--zbet-bubble-bottom',
      bar ? bottom + 'px' : 'calc(' + bottom + 'px + env(safe-area-inset-bottom, 0px))');

    /* Cookie-banneret: boblen vises ikke, mens banneret er fremme. CSS har
       samme regel med :has(); dette er nettet for browsere uden :has(). */
    var cookieUp = !!(cookieRoot && !cookieRoot.hidden);
    bubble.style.visibility = cookieUp ? 'hidden' : '';
  }

  if (bubble || card) {
    placeBubble();
    var tries = 0;
    var t = window.setInterval(function () {
      tries++;
      placeBubble();
      if (tries > 12) window.clearInterval(t);
    }, 400);
    window.addEventListener('load', placeBubble);
    window.addEventListener('resize', placeBubble, { passive: true });

    if ('MutationObserver' in window) {
      var mo = new MutationObserver(placeBubble);
      document.querySelectorAll('.zsticky').forEach(function (b) {
        mo.observe(b, { attributes: true, attributeFilter: ['class', 'style'] });
      });
      if (cookieRoot) mo.observe(cookieRoot, { attributes: true, attributeFilter: ['hidden'] });
    }
  }

  /* ---------- Start ---------- */
  refresh();
  window.setInterval(refresh, 60000);
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) refresh();
  });

  window.ZenBet = {
    refresh: function () { lastKey = ''; return refresh(); },
    open: function () { openCard(null); },
    close: function () { closeCard(false); },
    state: state
  };
})();
